import React from 'react';
import AppRootProvider from './providers/AppRootProvider';
import { errorConfig } from './requestErrorConfig';


export const reactQuery: { queryClient: any } = {
  queryClient: {
    defaultOptions: {
      queries: {
        staleTime: 5 * (60 * 1000), // 5 dakika
        cacheTime: 10 * (60 * 1000), // 10 dakika
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        retry: false,
      },
    },
  },
};

// @ts-ignore
export function rootContainer(container, args) {
  return React.createElement(AppRootProvider, args, container);
}

/**
 * @name İstek Yapılandırması
 * @description Hata işleme yapılandırılabilir.
 * Axios ve ahooks'un useRequest'i temel alınarak birleşik bir ağ isteği ve hata işleme çözümü sunar.
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...errorConfig,
};
